<template>
  <aside class="sidebar-wrapper">
    <div class="sidebar-header">
      <div
        class="logged-user"
        v-if="
          $route.path.includes('cliente') || $route.path.includes('producto')
        "
        v-show="permission1 || permission2"
      >
        <router-link
          to="/consulta"
          v-if="
            $route.path.includes('cliente') || $route.path.includes('producto')
          "
          v-show="permission1 || permission2"
        >
          <span class="volver" @click="toggleClass()">
            <!-- @click="toggleClass()" -->
            <font-awesome-icon icon="arrow-left" />Regresar a consulta de
            clientes
          </span>
        </router-link>
      </div>

      <div
        class="logged-user"
        v-if="
          $route.path.includes('cliente') || $route.path.includes('producto')
        "
      >
        <img
          class="logo-user"
          v-if="client"
          :src="require(`../assets/images/${logo}`)"
          alt
        />
        <section class="user-data" v-if="client">
          <h5>{{ client.Name }}</h5>
          <small>Client ID: {{ client.SubscrId }}</small>
        </section>
      </div>
    </div>
    <div class="sidebar-content">
      <ul class="sidebar-items">
        <li class="sidebar-item">
          <router-link
            to="/consulta"
            v-if="
              $route.path.includes('consulta') || $route.path.includes('manage')
            "
            v-show="permission1 || permission2"
          >
            <span class="icon-wrapper">
              <font-awesome-icon icon="user-check" />
            </span>
            <span class="sidebar-label" @click="toggleClass()"
              >Consulta de clientes</span
            >
          </router-link>
        </li>
        <li class="sidebar-item">
          <router-link
            to="/manage/new-account"
            v-if="
              $route.path.includes('consulta') || $route.path.includes('manage')
            "
            v-show="permission1 && permission2"
          >
            <span class="icon-wrapper">
              <font-awesome-icon icon="user-plus" />
            </span>
            <span class="sidebar-label" @click="toggleClass()"
              >Crear Usuario</span
            >
          </router-link>
        </li>

        <li class="sidebar-item">
          <router-link
            to="/managewebsite"
            v-if="
              $route.path.includes('consulta') || $route.path.includes('manage')
            "
            v-show="permission1 && permission2"
          >
            <span class="icon-wrapper">
              <font-awesome-icon icon="user-cog" />
            </span>
            <span class="sidebar-label" @click="toggleClass()"
              >Mantenimiento de Website</span
            >
          </router-link>
        </li>
        <li
          class="sidebar-item"
          v-if="
            $route.path.includes('cliente') || $route.path.includes('producto')
          "
        >
          <router-link
            :to="
              `/cliente/${
                client.SubscrId
              }/businessUnit/${client.BusinessUnitId ||
                clientBusinessUnit}/clientComercialName/${encodeURIComponent(
                clientComercialNameStore
              )}?customerId=${client.googleCustomerId ||
                0},${client.GoogleMyBusinessProfileId || 0}`
            "
          >
            <span class="icon-wrapper">
              <font-awesome-icon icon="file-contract" />
            </span>
            <span class="sidebar-label" @click="toggleClass()">Resumen</span>
            <!-- @click="toggleClass()" -->
          </router-link>
        </li>
        <li
          class="sidebar-item dropdown"
          v-bind:class="{ active: showDropdown }"
          v-on:click="showDropdown = !showDropdown"
          v-if="
            $route.path.includes('cliente') || $route.path.includes('producto')
          "
        >
          <a href="#">
            <span class="icon-wrapper">
              <font-awesome-icon icon="briefcase" />
            </span>
            <span class="sidebar-label">Productos</span>
          </a>
          <ul class="dropdown-menu">
            <li class="dropdown-item product-item"></li>

            <div
              class="container"
              v-for="product of products"
              :key="product.productId"
            >
              <li
                :class="`dropdown-item product-item product-${product.class} `"
                @click.stop
                @click="showWarning(product.isActived)"
              >
                <router-link
                  :class="`${!product.isActived ? 'inactive' : ''}`"
                  :to="
                    `/producto/${product.class}/${
                      product.productId
                    }/subscribers/${product.subscriberId}/businessUnit/${
                      product.businessUnitId
                    }/${(product.name || 'logo').replace(
                      / /g,
                      ''
                    )}?customerId=${getCustomerId(product)}`
                  "
                >
                  <span
                    :class="
                      `icon-wrapper bg-${!product.isActived ? 'inactive' : ''}`
                    "
                    v-if="product.class !== 'SLOLPR'"
                  >
                    <img
                      :src="
                        require(`../assets/images/products/${product.class}.svg`) ||
                          product.logo
                      "
                      alt="Isotipo"
                    />
                  </span>

                  <span class="icon-wrapper" v-if="product.class === 'SLOLPR'">
                    <img
                      class="img2"
                      :src="
                        require(`../assets/images/products/${product.class}.svg`) ||
                          product.logo
                      "
                      alt="Isotipo"
                    />
                  </span>
                  <span class="sidebar-label" @click="toggleClass()">{{
                    product.name
                  }}</span>
                  <!-- @click="toggleClass()" -->
                </router-link>
              </li>
            </div>
          </ul>
        </li>
      </ul>
    </div>
    <div v-if="googlePremierID" class="sidebar-footer">
      <a
        target="_blank"
        :href="`https://www.google.com/partners/agency?id=${googlePremierID}`"
      >
        <img
          :src="googlePartnerBadgeImage"
          alt="Badge de Google Partner"
        />
      </a>

      <small>
        {{ AllRightsReserved }}
        <br />
        {{ DesignedBy }}
      </small>
    </div>
  </aside>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { BUSINESS_UNIT_ID, CLASS_CODE } from "../constants";
import Warning from "./Warning.vue";

export default {
  name: "sidebar",
  data() {
    return {
      DesignedBy: "",
      AllRightsReserved: "",
      googlePremierID: localStorage.getItem("googlePremierID") || 5612063145,
      logo: localStorage.getItem("logo"),
      permission1: false,
      permission2: false,
      userData: {
        name: "Plásticos y Espejos",
        id: "5158"
      },
      modalData: null,
      modalActive: false,
      showDropdown: false,
      clientBusinessUnit: localStorage.getItem("businessUnitId"),
      googlePartnerBadgeImage: localStorage.getItem("googlePartnerBadgeImage")
    };
  },
  methods: {
    toggleClass: function() {
      if (screen.width <= 991) {
        if (this.sidebarIsActive) {
          // this.sidebarIsActive = false;
          this.$store.commit("FillsidebarIsActive", false);
        } else {
          // this.sidebarIsActive = true;
          this.$store.commit("FillsidebarIsActive", true);
        }
      }
    },
    getCustomerId: function(product) {
      switch (product.class) {
        case CLASS_CODE.GOOGLE_MY_BUSINESS:
          return product.googleMyBusinessProfileId;
        case CLASS_CODE.SPOTIFY:
          return product.spotifyAccountId;
        case CLASS_CODE.LINKEDIN:
          return product.linkedinAccountId;
        case CLASS_CODE.INFOPAGINAS:
          return product.infopaginasClientId;
        case CLASS_CODE.TIKTOK:
          return product.tiktokAccountId;
        default:
          return product.googleAccountId;
      }
    },
    showWarning: function(isActive) {
      if (!isActive) {
        setTimeout(() => {
          if (this.modalData) {
            this.$modal.show(Warning, this.modalData, {
              adaptive: true,
              height: 250
            });
          }
        }, 100);
      }
    }
  },
  created() {
    const businessUnitId = localStorage.getItem("businessUnitId");
    const year = new Date().getFullYear();
    this.modalData = {
      title: "Producto Inactivo",
      text:
        "Este producto se encuentra inactivo, por lo que se mostrarán las métricas hasta la fecha final del contrato. Ante cualquier duda o inconveniente, puede comunicarse con su agente representante."
    };

    if (Number(businessUnitId) === BUSINESS_UNIT_ID.RD) {
      this.DesignedBy = "Designed by Caribe Media";
      this.AllRightsReserved = "Caribe Media © All Rights Reserved " + year;
      this.modalData = {
        ...this.modalData,
        text:
          "Este producto se encuentra inactivo. Se mostrarán los resultados hasta la fecha que tuvo contratado este producto. Ante cualquier duda o pregunta, no dude en comunicarse con nosotros al ",
        phone: "809-220-3100."
      };
      // this.modalData = { ...this.modalData, phone: "809-220-3100" };
    } else if (Number(businessUnitId) === BUSINESS_UNIT_ID.PR) {
      this.DesignedBy = "Designed by Caribe Media";
      this.AllRightsReserved =
        "CMI Digital Media, LLC. © All Rights Reserved " + year;
      this.modalData = {
        ...this.modalData,
        text:
          "Este producto o servicio se encuentra actualmente inactivo. Se mostrarán los resultados hasta la fecha que tuvo contratado el mismo. Para cualquier duda o pregunta sobre las métricas de su publicidad, no dude en comunicarse con nosotros al ",
        phone: "787-771-6410",
        betweenText: "o escribir a ",
        email: "customerservice@axesa.com."
      };
      // this.modalData = { ...this.modalData, phone: "787-771-6410" };
    } else if (Number(businessUnitId) === BUSINESS_UNIT_ID.IP) {
      this.DesignedBy = "Designed by Caribe Media";
      this.AllRightsReserved = "Infomedia © All Rights Reserved " + year;
      this.modalData = {
        ...this.modalData,
        text:
          "Este producto se encuentra inactivo. Se mostrarán los resultados hasta la fecha que tuvo contratado este producto. Ante cualquier duda o pregunta, no dude en comunicarse con nosotros al ",
        phone: "787-625-0555."
      };
    }

    const roll = localStorage.getItem("roll");
    if (roll === "Administrator") {
      this.permission1 = true;
      this.permission2 = true;
    }
    if (roll === "Consulting") {
      this.permission1 = true;
      this.permission2 = false;
    }
    if (roll === "Customer") {
      this.permission1 = false;
      this.permission2 = false;
    }
  },
  computed: {
    ...mapState(["client"]),
    ...mapGetters([
      "products",
      "currentBusiness",
      "client",
      "sidebarIsActive",
      "clientComercialNameStore"
    ])
  }
};
</script>
<style lang="scss" scoped>
.sidebar-volver {
  margin: auto 10%;
  padding: 10px;
  text-align: center;
}
.sidebar-wrapper {
  width: 85%;
  height: 100%;
  background-color: $white;
  position: fixed;
  left: -80%;
  transition: $default-transition;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;

  &.active {
    left: 0;
  }
}

.go-back {
  padding: 10px 20px;
  border-bottom: $separator;
  flex-shrink: 0;
  .icon-wrapper {
    margin-right: 10px;
  }
}
.sidebar-header {
  flex-shrink: 0;
  padding-top: 60px;
  .logged-user {
    padding: 15px 20px;
    display: flex;
  }
  .user-data {
    flex-grow: 1;
    h5 {
      color: $subtitle-color;
    }
    small {
      color: $text-color;
      font-size: 14px;
    }
  }
}

// .inactive::after{
//   content: "";
//   position:absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: #bcbcbc7a;
// }

.sidebar-content {
  overflow-y: auto;
  .sidebar-title {
    padding: 20px 20px 10px;
    color: $sidebar-title-color;
    font-weight: 500;
    h5 {
      font-size: 14px;
    }
  }
  .sidebar-items {
    margin-bottom: 60px;
    .sidebar-item {
      position: relative;
      a {
        color: $neutral-gray-500;
        text-decoration: none;
        display: block;
        font-weight: $font-normal;
        transition: $default-transition;

        .icon-wrapper {
          width: 22px;
          height: 22px;
          top: 15px;
          left: 17px;
          display: flex;
          position: absolute;
          color: $primary-500;
          text-align: center;
        }
        span.sidebar-label {
          padding: 15px 20px 15px 45px;
          display: block;
          &::before {
            content: "";
            width: 6px;
            height: 100%;
            background-color: $primary-600;
            display: block;
            position: absolute;
            top: 0;
            left: -6px;
            transition: $default-transition;
          }
        }
        &.router-link-active {
          background-color: $bkg-color;
          color: $primary-600;
          border: none;
          color: $primary-600;
          span.sidebar-label {
            &::before {
              left: 0px;
            }
          }
          .icon-wrapper {
            color: $primary-600;
          }
          &::before {
            content: "";
            width: 15px;
            height: 15px;
            background-image: url("../assets/images/item-active.svg");
            background-size: 15px;
            display: block;
            position: absolute;
            right: 0;
            top: -15px;
          }
          &::after {
            content: "";
            width: 15px;
            height: 15px;
            background-image: url("../assets/images/item-active.svg");
            background-size: 15px;
            display: block;
            position: absolute;
            right: 0;
            bottom: -15px;
            transform: rotate(270deg);
          }
          & + li > a {
            border: none;
          }
        }
        &:hover {
          .icon-wrapper {
            color: $primary-500;
          }
          span.sidebar-label {
            color: $primary-500;
            &::before {
              left: 0;
              background-color: $primary-500;
            }
          }
        }
      }
      &.dropdown {
        &::after {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 6px solid $blueish-gray-700;
          top: 23px;
          right: 20px;
          transform: rotate(90deg);
          border-radius: 10px;
        }
        &.active {
          & > a {
            span.sidebar-label {
              position: relative;
              &::before {
                content: "";
                width: 6px;
                height: 100%;
                background-color: $secondary-orange-500;
                display: block;
                position: absolute;
                top: 0;
                left: 0;
              }
            }
          }
        }
        .dropdown-item {
          position: relative;
          transition: $default-transition;
          .icon-wrapper {
            top: 11px;
          }
          .sidebar-label {
            padding: 12px 20px 12px 45px;
          }
          &.active {
            background-color: $bkg-color;
            color: $primary-600;
            border-top: none;
            & + li {
              border-top: none;
            }
            a {
              color: $primary-600;
              &::before {
                content: "";
                width: 6px;
                height: 100%;
                display: block;
                position: absolute;
                top: 0;
                left: 0;
              }
            }
            .icon-wrapper {
              background-color: $white !important;
              box-shadow: $default-shadow;
            }
            &::before {
              content: "";
              width: 15px;
              height: 15px;
              background-image: url("../assets/images/item-active.svg");
              background-size: 15px;
              display: block;
              position: absolute;
              right: 0;
              top: -15px;
            }
            &::after {
              content: "";
              width: 15px;
              height: 15px;
              background-image: url("../assets/images/item-active.svg");
              background-size: 15px;
              display: block;
              position: absolute;
              right: 0;
              bottom: -15px;
              transform: rotate(270deg);
            }
          }
        }
        &.active {
          &::after {
            border-bottom: 6px solid $secondary-orange-500;
            transform: rotate(180deg);
          }
          & > a {
            color: $secondary-orange-500;
            font-weight: $font-medium;
          }
          & a > .icon-wrapper {
            color: $secondary-orange-500;
          }
          & > .dropdown-menu {
            display: block;
          }
        }
      }

      .dropdown-menu {
        display: none;
        li[class^="product-"].dropdown-item a .icon-wrapper {
          background-color: #333333;
        }
      }
      a.inactive {
        position: relative;
        // width: 100%;
        // height: 100%;
        background-color: #ebebeb7a;
        .icon-wrapper {
          background-color: none !important;
          img {
            -webkit-filter: grayscale(100%);
            filter: grayscale(100%);
          }
        }
        .sidebar-label {
          &::before {
            background-color: #5f5f5f !important;
          }
        }
      }
    }
  }
}

.product-item {
  &.product-paginas-amarillas,
  &.product-SPPG {
    .sidebar-label {
      &::before {
        background-color: $pa-color !important;
      }
    }
  }
  &.product-places-to-go {
    .sidebar-label {
      &::before {
        background-color: $ptg-color !important;
      }
    }
  }

  &.product-PTGPR,
  &.product-SLOLPR {
    .sidebar-label {
      &::before {
        background-color: $ptgpr-color !important;
      }
    }
  }

  &.product-salud-online,
  &.product-SLOL {
    .sidebar-label {
      &::before {
        background-color: $saludonline-color !important;
      }
    }
  }
  &.product-salud-online,
  &.product-SLOL {
    .sidebar-label {
      &::before {
        background-color: $saludonline-color !important;
      }
    }
  }
  &.product-amchamdr-online,
  &.product-AMOL {
    .sidebar-label {
      &::before {
        background-color: $amchamdr-color !important;
      }
    }
  }
  &.product-the-business-register,
  &.product-BRIN {
    .sidebar-label {
      &::before {
        background-color: $tbr-color !important;
      }
    }
  }
  &.product-google {
    .sidebar-label {
      &::before {
        background-color: $google-color !important;
      }
    }
  }
  &.product-fb {
    .sidebar-label {
      &::before {
        background-color: $fb-color !important;
      }
    }
  }
  &.product-ig {
    .sidebar-label {
      &::before {
        background-color: $ig-color !important;
      }
    }
  }
  &.product-waze {
    .sidebar-label {
      &::before {
        background-color: $waze-color !important;
      }
    }
  }
  &.product-youtube {
    .sidebar-label {
      &::before {
        background-color: $youtube-color !important;
      }
    }
  }
  &.product-SEBP-DA {
    .sidebar-label {
      &::before {
        background-color: $discovery-color !important;
      }
    }
  }
  &.product-SEBP-PM {
    .icon-wrapper {
      background-color: $secondary-yellow-200 !important;
    }
    .sidebar-label {
      &::before {
        background-color: $max-performance-color-2 !important;
      }
    }
  }
  &.product-SEBP-CL {
    .icon-wrapper {
      background-color: rgb(250, 248, 144) !important;
    }
    .sidebar-label {
      &::before {
        background-color: rgb(248, 245, 111) !important;
      }
    }
  }
  &.product-SPY {
    // .icon-wrapper {
    //   background-color: rgb(144, 250, 156) !important;
    // }
    .sidebar-label {
      &::before {
        background-color: #2fbd59 !important;
      }
    }
  }
}

.sidebar-footer {
  display: flex;
  flex-direction: column;
  padding: 8px 20px;
  background-color: $white;
  border-top: $separator;
  box-sizing: border-box;
  bottom: 0;
  width: 100%;
  flex-shrink: 0;
  position: absolute;
  // height: 110px;
  img {
    width: 50px;
    margin-bottom: 3px;
  }
  small {
    font-size: 8px;
    line-height: 0.8rem;
  }
}
@include respond-above(sm) {
  .sidebar-content {
    .sidebar-items {
      margin-bottom: 116px;
    }
  }
  .sidebar-footer {
    // height: 110px;
    padding: 15px 20px;
    img {
      width: 80px;
    }
    small {
      font-size: 12px;
      line-height: 1rem;
    }
  }
}

.bg-inactive {
  background-color: #e6e6e6 !important;
}

.sidebar-header {
  flex-shrink: 0;
  padding-top: 60px;
  .logged-user {
    padding: 15px 20px;
    display: flex;
    border-bottom: $separator;
    align-items: center;
    .logo-user {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: $separator;
      margin-right: 10px;
    }
  }
}
</style>
